import React from "react";
import { motion } from "framer-motion";

export default function Pricing() {
  return (
    <div>
      <section
      id="pricing"
      className="py-5 bg-gradient-to-b from-gray-50 via-white to-gray-100"
      style={{ textAlign: "center" }}
    >
      <div className="container">
        {/* 🧾 Section Heading */}
        <motion.h2
          className="fw-bold mb-4"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            fontSize: "2.2rem",
          }}
        >
          Pricing &{" "}
          <span
            style={{
              background: "linear-gradient(90deg,#ff006e,#ff8c00)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Proposal
          </span>
        </motion.h2>

        {/* 💬 Subtitle Line */}
        <motion.p
          className="lead text-black mx-auto mb-5"
          style={{
            maxWidth: "800px",
            lineHeight: "1.7",
            fontSize: "1.25rem",
          }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7 }}
        >
          No off-the-shelf plans. Every scope is customized based on brand goals,
          deliverables, talent categories, timelines, and performance KPIs.
        </motion.p>

        {/* 🪄 CTA Button */}
        <motion.a
          href="#contact"
          className="btn btn-lg px-5 py-3 fw-semibold"
          style={{
            background:
              "linear-gradient(90deg, rgba(255,0,110,1) 0%, rgba(255,140,0,1) 100%)",
            border: "none",
            color: "#fff",
            borderRadius: "50px",
            boxShadow: "0 6px 18px rgba(255,0,110,0.25)",
            transition: "all 0.3s ease",
          }}
          whileHover={{
            scale: 1.08,
            boxShadow: "0 10px 25px rgba(255,0,110,0.35)",
          }}
          whileTap={{ scale: 0.97 }}
        >
          Tell us your goal. We’ll build the strategy.
        </motion.a>
      </div>
    </section>
    
    </div>
  );
}
